export default __webpack_public_path__ + "static/2382-74cd848e1bd7b4d03bfbe25ea4994df2.gif";